import React, { useMemo, useState } from 'react';
import { DbComponentItemType, ComponentInfoType, DbCompontentGroupInfoType } from '@/pages/dashboard/types/dashboard';
// import { FILTER_TYPE_COMMON, FILTER_TYPE_SEFL } from '@/pages/dashboard/_config/constant';
// import ComponentsMap from '@/pages/dashboard/_config/compontents';
import DbComponentItem from '@/pages/dashboard/components/DbComponent/DbCompontentItem';
import FiltersMap from '@/pages/dashboard/_config/filters';
interface DbComponentGroupProps {
  info: DbCompontentGroupInfoType;
  gameCode: string;
  timeZone: string | undefined;
}

const DbComponentGroup =  (props: DbComponentGroupProps) => {
  const [formValue, setFormValue] = useState<any>(null);
  const [filterLoading, setFilterLoading] = useState<boolean>(true);
  const [isZoneTimeInit, setIsZoneTimeInit] = useState<boolean>(false)
  const { info: { group, type, components }, gameCode, timeZone } = props;

  // models 载入
  // const models = useMemo(() => {}, [components]);

  const handleFilterChange = (value: any) => {
    setFormValue(value);
  }

  // @ts-ignore
  const { Filter } = FiltersMap[group];

  return (
    <>
      <Filter
        filterConfirm={handleFilterChange}
        filterReset={handleFilterChange}
        timeZone={timeZone}
        buttonLogConfig={{ pageId:'120002',confirmButtonId:'120002001',resetButtonId:'120002002'}}
        filterLoading={filterLoading}
        setFilterLoading={setFilterLoading}
        filterInit={setFormValue}
        setIsZoneTimeInit={setIsZoneTimeInit}
      />
      {
        components.map((item) => {
          return <DbComponentItem formValue={formValue} gameCode={gameCode} filterLoading={filterLoading} info={item} key={item.name} />
        })
      }
    </>
  );
}

export default DbComponentGroup;
